export default {
	locale: "en-US", // probaly array of all possible locales, first one would be default

	// Logo file name in ../assets/img/
	// If null show placeholder
	logo: "hkecic_logo.png",

	// Some design changes per tenant
	theme: {
		logoBackgroundColor: "white" //any valid css value for colors
	},

	// we use dayjs syntax: https://github.com/iamkun/dayjs/blob/master/docs/en/API-reference.md#format-formatstringwithtokens-string
	dateFormat: "DD/MM/YYYY",
	dateTimeFormat: "DD/MM/YYYY HH:mm:ss",

	// ENUM of preferred currency
	// ENUMs of currencies are defined in localization
	preferredCurrency: "HKD",

	// Flags for development in case we need some flags to show/hide some features for development
	devFlags: {
		hasCommissions: true,
		hasFakeSettings: true,
		hasAdvancedUserManagement: true,
		hasPolicyActions: true,
		hasQuoteActions: true
	},

	// Settings for files upload
	filesUpload: {
		types: [
			"jpg",
			"jpeg",
			"png",
			"gif",
			"tiff",
			"webp",
			"pdf",
			"doc",
			"xdoc",
			"csv",
			"xls",
			"xlsx",
			"zip",
			"rar",
			"txt"
		],
		maxFileSize: 15 * 1024 * 1024
	},

	// What features can be seen by this client
	// Affects top menu and router global guard
	// id is used in router to prevent showing features that are not allowed
	// name and slug are used for menu in UI
	features: [
		"dashboard",
		"clients",
		"policies",
		"caseManagement",
		"products",
		"reports",
		"users",
		"internals",
		"organizations",
		"setup"
	],

	// Feature Dashboard
	dashboard: {
		detail: {
			hasNumberOfClients: true,
			hasNumberOfPolicies: true,
			hasNumberOfCases: true,
			hasGraph: true
		}
	},

	// Feature clients
	clients: {},

	// Feature Quotes
	quotes: {
		actions: {
			hasActions: true,
			hasRequestPayment: false,
			hasIssuePolicy: true
		},

		offers: {
			hasSendOffer: false
		},

		detail: {
			hasReject: true,
			hasChangeHolder: true,
			hasAddOtherHolder: true,
			hasRemoveOtherHolder: true,
			hasAddInsured: true,
			hasRemoveInsured: true
		}
	},

	// Feature policies
	policies: {
		creating: {
			hasApiCreation: true,
			hasManualCreation: true
		},
		actions: {
			hasActions: false,
			hasRequestPayment: false,
			hasSendConfirmation: false
		},
		cancelling: {
			hasCancel: true,
			hasSendEmail: false
		}
	},

	// Feature Reports
	reports: {
		reporting: {
			hasAEG: true
		}
	},

	// Products
	products: {
		hasUnderwritingEditor: true,
		hasPricingEditor: true,
		hasBenefitsEditor: true
	}
}
